import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReplaySubject} from "rxjs";
import {Contract} from "../../../../shared/interface/contract";
import {ContractService} from "../../../../shared/services/contract.service";
import {first} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {ContractInitialBalance} from "../../../../shared/interface/contract-initial-balance";
import {ContractInitialBalanceService} from "../../../../shared/services/contract-initial-balance.service";
import {ContractBalance} from "../../../../shared/interface/contract-balance";

export interface AddInitialBalanceData {
  contract?: Contract;
}
@Component({
  selector: 'app-add-initial-balance',
  templateUrl: './add-initial-balance.component.html',
  styleUrls: ['./add-initial-balance.component.scss']
})
export class AddInitialBalanceComponent implements OnInit, OnDestroy, AfterViewInit {

  processingRequest = false;
  contract?: Contract = null;
  contractObject: Contract;
  contractBalanceToPayNet?: number;
  contractBalanceInitialBalanceNet?: number;
  contractBalanceInitialBalanceSwap?: number;
  contractBalanceTotalCommission?: number;
  contractBalanceContract?: string;
  contractName?: string;
  contractBalancePaid?: number;
  contractBalanceUuid?: string;
  contracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  contractBalanceForm: FormGroup;
  initialBalanceControl: FormControl;
  contractBalanceContractControll: FormControl;
  noteControl: FormControl;
  formErrors = {};
  contractBalanceObject: ContractBalance;
  contractInitialBalanceObject: ContractInitialBalance[];
  displayedColumns: string[] = ['net', 'note', 'date', 'user'];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private contractService: ContractService,
    private contractInitialBalance: ContractInitialBalanceService,
    public dialogRef: MatDialogRef<AddInitialBalanceComponent>,
    private snack: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: AddInitialBalanceData,
    private formHelper: FormHelperService,

  ) {
    this.contract = data.contract;
    this.contractBalanceForm = fb.group({
      initialBalanceNet: this.initialBalanceControl = fb.control('', [Validators.required]),
      note: this.noteControl = fb.control('', [Validators.required]),
      contractBalance: this.contractBalanceContractControll = fb.control(''),
    });
  }

  ngOnInit(): void {
    this.initialBalanceControl.setValue(0.00);
    this.loadContract(this.contract);
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  ngAfterViewInit(): void {

  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
  loadContract(contractId): void {
    if (contractId) {
      this.contractService.get(contractId)
        .subscribe((contract: Contract) => {
          this.contractBalanceToPayNet = contract.contractBalance?.toPayNet;
          this.contractBalanceInitialBalanceNet = contract.contractBalance?.initialBalanceNet;
          this.contractBalanceInitialBalanceSwap = contract.contractBalance?.swap;
          this.contractBalanceTotalCommission = contract.contractBalance?.totalCommission;
          this.contractBalancePaid = contract.contractBalance?.paid;
          this.contractBalanceContract = contract.uuid;
          this.contractName = contract.number;
          this.contractBalanceUuid = contract.contractBalance.uuid;
          this.contractBalanceContractControll.setValue(contract.contractBalance.uuid);
          this.contractBalanceObject = contract.contractBalance;
          this.contractBalanceObject.contractInitialBalances.sort((a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
          this.contractObject = contract;
        });
    }
  }
  cancel(): void {
    this.dialogRef.close(true);
  }
  sendForm(): void {
    this.processingRequest = true;
    this.contractInitialBalance.sendForm(this.contractBalanceForm.getRawValue())
      .pipe(
        first()
      ).subscribe((response: Uuid) => {
      this.snack.open('Pomyślnie utworzono saldo początkowe', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      this.dialogRef.close(true);
    }, (error: HttpErrorResponse) => {
      this.processingRequest = false;
      this.dialogRef.close(false);
      this.snack.open('Podczas dodawania salda początkowego wystąpił błąd', error.status.toString(), {
        duration: 2000,
      });

      if (error.status === 400) {
        this.formErrors = error.error.error.list;
        this.formHelper.setBackendErrorState(this.contractBalanceForm, this.formErrors);
      }
    })
    ;
  }

  sum(valA: unknown, valB: unknown): number {
    const valueA = Number(valA ?? 0);
    const valueB = Number(valB ?? 0);

    return (
      (Number.isFinite(valueA) ? valueA : 0) +
      (Number.isFinite(valueB) ? valueB : 0)
    );
  }

}
